var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_25522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7844 9.03903L14.2211 7.60233C14.2998 7.52345 14.344 7.41657 14.344 7.30515C14.344 7.19372 14.2998 7.08685 14.2211 7.00796L12.7845 5.57129C12.72 5.50845 12.6333 5.47355 12.5433 5.47413C12.4532 5.47471 12.367 5.51074 12.3033 5.57441C12.2396 5.63808 12.2036 5.72427 12.203 5.81433C12.2024 5.90438 12.2373 5.99104 12.3001 6.05555L13.2072 6.96263H0.686447C0.595623 6.96263 0.508519 6.99871 0.444296 7.06293C0.380074 7.12715 0.343994 7.21426 0.343994 7.30508C0.343994 7.3959 0.380074 7.48301 0.444296 7.54723C0.508519 7.61145 0.595623 7.64753 0.686447 7.64753H13.2071L12.3001 8.55477C12.2367 8.61916 12.2013 8.70601 12.2017 8.79639C12.202 8.88676 12.2381 8.97333 12.302 9.03724C12.3659 9.10115 12.4524 9.1372 12.5428 9.13755C12.6332 9.1379 12.72 9.10252 12.7844 9.03911V9.03903Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_25522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.343994 0.305176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightBar);
export default __webpack_public_path__ + "static/media/icon-arrow-right-bar.79b049ebb84dafd8ddd180837165b62c.svg";
export { ForwardRef as ReactComponent };